import React, { useEffect } from 'react';
import Sheet from 'react-modal-sheet';
import Button from './common/Button';
import useDialogA11y from '../hooks/useDialogA11y';
import DelayedMaskInput from './common/DelayedMaskInput';
import './OtpSheet.css';

const APP_FOOTER_HEIGHT = 48;

const OtpSheet = ({
	isOpen,
	onClose,
	customDetails,
	mobileNumber,
	OTP,
	otpError,
	time,
	isResend,
	verifySpinner,
	isVerifyDisabled,
	onOTPChange,
	onResendOtp,
	onVerifyOtp,
}) => {
	const dialogRef = useDialogA11y(isOpen, onClose);

	useEffect(() => {
		if (!isOpen) return undefined;

		const previousOverflow = document.body.style.overflow;
		document.body.classList.add('otp-sheet-open');
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.classList.remove('otp-sheet-open');
			document.body.style.overflow = previousOverflow;
		};
	}, [isOpen]);

	return (
		<Sheet
			snapPoints={[400]}
			disableDrag={true}
			isOpen={isOpen}
			onClose={onClose}
			className="otp-sheet"
		>
			<Sheet.Container style={{ bottom: APP_FOOTER_HEIGHT }}>
				<Sheet.Content disableDrag={true}>
					<div
						ref={dialogRef}
						className="row mx-4"
						role="dialog"
						aria-modal="true"
						aria-labelledby="otp-sheet-title"
					>
						<div className="col-12">
							<h2
								id="otp-sheet-title"
								className="fs-16 fw-700 text-start mt-4"
								style={{
									fontFamily: customDetails?.fontFamily,
									textAlign: 'left',
									color: 'black',
								}}
							>
								Verify mobile number
							</h2>
						</div>
						<div className="col-12">
							<p
								className="fs-16 fw-500 text-start mt-1"
								style={{
									color: customDetails?.textColor,
									fontFamily: customDetails?.fontFamily,
								}}
							>
								Please enter the OTP sent to your registered mobile number
							</p>
						</div>
						<div className="col-12">
							<label htmlFor="otp-sheet-input" className="form-field-label">
								One-time password (OTP)
							</label>
							<DelayedMaskInput
								id="otp-sheet-input"
								className="form-control mb-1"
								value={OTP}
								maxLength={8}
								onChange={onOTPChange}
								onEnter={(e) => {
									if (!isVerifyDisabled) {
										e.preventDefault();
										onVerifyOtp();
									}
								}}
								autoFocus
								aria-invalid={otpError ? 'true' : undefined}
								aria-describedby={otpError ? 'otp-sheet-error' : undefined}
								style={{
									height: '50px',
									fontFamily: customDetails?.fontFamily,
									borderColor: otpError ? '#c62828' : undefined,
								}}
							/>
							{otpError && (
								<p id="otp-sheet-error" className="form-field-error" role="alert">
									{otpError}
								</p>
							)}
							<div className="d-flex align-items-center">
								<button
									type="button"
									className="fs-14 fw-600 link-btn"
									disabled={!isResend}
									aria-label="Resend OTP"
									style={{
										color: isResend ? customDetails?.primaryBtnColor : '#6B6D6F',
									}}
									onClick={onResendOtp}
								>
									Didn't recieve OTP ? Try again
								</button>
								{time !== 60 ? (
									<p
										className="fs-14 fw-600 my-auto"
										aria-live="polite"
										aria-atomic="true"
										style={{
											fontFamily: customDetails?.fontFamily,
											color: '#6B6D6F',
										}}
									>
										in {time} secs
									</p>
								) : null}
							</div>
						</div>
						<div className="col-12 d-flex justify-content-center mb-4">
							<Button
								type="button"
								disabled={isVerifyDisabled}
								onClick={onVerifyOtp}
								aria-busy={verifySpinner}
								aria-label={verifySpinner ? 'Verifying OTP' : 'Verify OTP'}
								color={customDetails?.primaryBtnColor}
								fontFamily={customDetails?.fontFamily}
								fontSize={customDetails?.fontSize}
								size="medium"
								padding="default"
								style={{
									height: customDetails?.btnHeight,
									width: customDetails?.btnWidth,
									borderRadius: customDetails?.borderRadius,
									marginTop: '1rem',
								}}
								className="float-end fs-16 fw-600 text-white mt-3"
							>
								{verifySpinner ? (
									<div
										className="snippet"
										style={{ display: 'flex', justifyContent: 'center' }}
										data-title=".dot-pulse"
										aria-hidden="true"
									>
										<div className="stage">
											<div className="dot-pulse-btn"></div>
										</div>
									</div>
								) : (
									'VERIFY'
								)}
							</Button>
						</div>
					</div>
				</Sheet.Content>
			</Sheet.Container>
			<Sheet.Backdrop
				style={{
					top: 0,
					bottom: APP_FOOTER_HEIGHT,
					height: 'auto',
				}}
			/>
		</Sheet>
	);
};

export default OtpSheet;
